import { makeStyles } from '@mui/styles';

export const usePricingRulesPriceAdjustmentStyle = makeStyles(() => ({
  relativeTo: {
    width: 80,
    minWidth: 80,
  },
}));
